import { render, staticRenderFns } from "./ActivityResults.vue?vue&type=template&id=197f4248&scoped=true&"
import script from "./ActivityResults.vue?vue&type=script&lang=js&"
export * from "./ActivityResults.vue?vue&type=script&lang=js&"
import style0 from "./ActivityResults.vue?vue&type=style&index=0&id=197f4248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f4248",
  null
  
)

export default component.exports